import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vue from "vue";
import VueSpinners from "vue-spinners";
import VOtpInput from "vue3-otp-input";

import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Sidebar from "primevue/sidebar";
import Button from "primevue/button";
import Menu from "primevue/menu";
import Dialog from "primevue/dialog";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Calendar from "primevue/calendar";
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';


//Date picker
import InputNumber from "primevue/inputnumber";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import VTooltip from 'v-tooltip'



//Chartjs

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
);

//Primevue
import Chips from "primevue/chips";
import Primevue from "primevue/config";
import ProgressBar from "primevue/progressbar";
import "primevue/resources/themes/lara-light-teal/theme.css";

//ANTD
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

//Toast
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const options = {
  // You can set your default options here
  timeout: 2000,
};
import { useToast } from "vue-toastification";

//Date picker css
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

//google map
import * as VueGoogleMaps from "vue2-google-maps";

//Custom Font
import "@fontsource-variable/inter";
import "./assets/styles/main.css";


// Implementation
const app = createApp(App);



app.config.globalProperties.$toast = useToast();

createApp(App)
  .use(Primevue)
  // .use(VueGoogleMaps, {
  //   load: {
  //     key: ' process.env.VUE_GOOGLE_MAPS_API_KEY',
  //     // other options...
  //   },
  // })
  .use(VueSpinners)
  .use(store)
  .use(router)
  .use(Toast, options)
  .use(Antd)
  .use(VTooltip)
  .component("VueDatePicker", VueCtkDateTimePicker)
  .component("InputText", InputText)
  .component("Chips", Chips)
  .component("InputNumber", InputNumber)
  .component("Dropdown", Dropdown)
  .component("ProgressBar", ProgressBar)
  .component("MultiSelect", MultiSelect)
  .component("InputSwitch", InputSwitch)
  .component("DataTable", DataTable)
  .component("Column", Column)
  .component("Sidebar", Sidebar)
  .component("Button", Button)
  .component("Menu", Menu)
  .component("Dialog", Dialog)
  .component("TabPanel", TabPanel)
  .component("TabView", TabView)
  .component("Calendar", Calendar)
  .component("Checkbox", Checkbox)
  .component("RadioButton", RadioButton)
  .directive("tooltip", Tooltip)
  .component("v-otp-input", VOtpInput)
  .mount("#app");

export const { toast } = useToast();
